import { render, staticRenderFns } from "./ManufacturingCommentsCard.vue?vue&type=template&id=3c3287ab&"
import script from "./ManufacturingCommentsCard.vue?vue&type=script&lang=js&"
export * from "./ManufacturingCommentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports